import Vue from 'vue';
import Vuex from 'vuex';

// import { IUserState, UserModule } from './modules/user/user.store';
// import { ISystemState, SystemModule } from './modules/system/system.store';
// import { IRealmsState, RealmsModule } from './modules/realms/realms.store';
// import { IAdminState, AdminModule } from './modules/admin/admin.store';

Vue.use(Vuex);

export interface IRootState {
	// UserModule: IUserState;
	// SystemModule: ISystemState;
	// RealmsModule: IRealmsState;
	// AdminModule: IAdminState;
}

export default new Vuex.Store<IRootState>({});
